import { render, staticRenderFns } from "./stampaEtichette.vue?vue&type=template&id=7b7df6f0"
import script from "./stampaEtichette.vue?vue&type=script&lang=js"
export * from "./stampaEtichette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports